import React, { useState } from "react"

const faqItems = [
  {
    question: "What is Filmustage, and how does it help filmmakers?",
    answer: `Filmustage is a platform using proprietary AI technology to simplify and optimize pre-production tasks such as script breakdowns, shooting scheduling, and budget management, making the process more efficient, cost-effective, and less prone to errors.`,
  },
  {
    question:
      "How does Filmustage ensure efficient project management and collaboration?",
    answer: `Filmustage provides a unified platform for script breakdown, budgeting, and scheduling, ensuring smooth collaboration across production teams with features like Team Access, and integrates seamlessly with industry-standard software.`,
  },
  {
    question: "What are the benefits of using Filmustage for pre-production?",
    answer: `Filmustage offers time and cost savings by transforming tedious tasks into quick steps, enabling filmmakers to focus more on creativity rather than logistics, and streamlining resource allocation with its advanced AI tools.`,
  },
  {
    question:
      "How does Filmustage's AI Script Analysis assist in pre-production?",
    answer: `Filmustage's AI Analysis feature undertakes critical evaluations of the script, including legal, safety, and pre-production challenges, ensuring a smooth translation of the story to the screen without hindering the creative flow.`,
  },
  {
    question: "How does Filmustage automate script breakdowns?",
    answer: `Filmustage automatically identifies critical script elements like cast, props, locations, and VFX, streamlining the planning process and saving valuable time and costs by making pre-production planning more efficient.`,
  },
  {
    question: "What risk management tools does Filmustage offer?",
    answer: `Filmustage identifies scenes needing additional preparation, providing information on animal involvement, environmental precautions, and the necessity for COVID-19 restrictions, ensuring on-set security and smooth filming.`,
  },
  {
    question:
      "What features does Filmustage offer to simplify film scheduling?",
    answer: `Filmustage offers features like auto time estimates, real location tagging, and drag-and-drop scene management to automate and enhance the precision of film scheduling, saving time and making the production process smoother.`,
  },
  {
    question: "Is Filmustage compatible with my existing production software?",
    answer: `Filmustage is designed to integrate seamlessly with industry-standard production software, including Movie Magic, Gorilla Scheduling, and Final Draft, enhancing your existing workflow without replacing the tools you're accustomed to.`,
  },
  {
    question: "Can Filmustage generate script synopses automatically?",
    answer: `Yes, Filmustage can automate the creation of comprehensive script synopses in just minutes, eliminating the need for lengthy reading and summarizing traditionally required during pre-production stages.`,
  },
  {
    question: "Is Filmustage easy to use for filmmakers of all skill levels?",
    answer: `Yes, Filmustage is designed to be intuitive and user-friendly, catering to filmmakers of all levels. With simple UX and 24/7 live support, getting started and navigating the platform is straightforward for all users.`,
  },
]

const FAQItem = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <li
      onClick={() => setIsOpen(!isOpen)}
      style={{
        position: "relative",
        marginLeft: "2rem",
      }}
    >
      <h4
        className="text-gray-200 hover:text-gray-400 text-lg font-medium mb-2 cursor-pointer underline decoration-solid decoration-1 underline-offset-4 decoration-gray-500/90"
        data-aos="fade-up"
        data-aos-delay={`${100 * index}`}
      >
        <button
          className={`hamburger ${isOpen ? "active" : ""}`}
          style={{
            position: "absolute",
            zIndex: 1,
            marginLeft: "-2rem",
            marginTop: "0.18rem",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            className="w-6 h-6 fill-current text-gray-300 hover:text-gray-200 transition duration-150 ease-in-out"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="4" width="24" height="2" rx="1" />
            <rect y="11" width="24" height="2" rx="1" />
            <rect y="18" width="24" height="2" rx="1" />
          </svg>
        </button>
        {question}
      </h4>

      <p
        className={`text-lg text-gray-400 mb-5 ${isOpen ? "block" : "hidden"}`}
        dangerouslySetInnerHTML={{ __html: answer }}
      ></p>
    </li>
  )
}

function Faqs({ htmlStringData }) {
  let localFaqItems = faqItems

  if (htmlStringData) {
    const questionRegex = /<li class="faq_question">([^<]*)<\/li>/g
    const answerRegex = /<li class="faq_answer">([^<]*)<\/li>/g

    function extractContent(regex, string) {
      let matches = []
      let match
      while ((match = regex.exec(string)) !== null) {
        matches.push(match[1].trim())
      }
      return matches
    }

    const faqQuestions = extractContent(questionRegex, htmlStringData)
    const faqAnswers = extractContent(answerRegex, htmlStringData)

    if (faqQuestions.length > 0 && faqAnswers.length > 0) {
      const newFaqItems = faqQuestions
        .map((question, index) => {
          const answer = faqAnswers[index] || ""

          return { question: question.trim(), answer: answer.trim() }
        })
        .filter(item => item.question !== "" && item.answer !== "")

      if (newFaqItems.length > 0) {
        localFaqItems = newFaqItems
      }
    }
  }

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          <div className="max-w-3xl mx-auto text-center pb-12">
            <h2 className="h2" data-aos="fade-up">
              Frequently asked questions
            </h2>
          </div>

          <ul
            className="grid md:grid-cols-2 gap-x-10 gap-y-4 max-w-6xl mx-auto"
            data-aos="fade-up"
          >
            {localFaqItems.map((item, index) => (
              <FAQItem
                key={index}
                question={item.question}
                answer={item.answer}
                index={index}
              />
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Faqs
